import Vue from 'vue';
import { Module } from 'vuex';

import { Chapter, RootState } from 'frontend/types';

import { postData } from 'frontend/utils/ajax';

interface IChaptersState {
  items: Chapter[] | undefined;
}

const chapters: Module<IChaptersState, RootState> = {
  namespaced: true,
  state: () => ({
    items: undefined,
  }),
  getters: {
    chapters: state => state.items,
  },
  mutations: {
    setValue(state, value: Chapter[]): void {
      Vue.set(state, 'items', value);
    },
    setNotifyComingSoon(state, { chapterId }) {
      if (state.items) {
        state.items.forEach(chapter => {
          if (chapter.chapter_id === chapterId) {
            chapter.notify_when_published = true;
          }
        });
      }
    },
  },
  actions: {
    notifyComingSoon({ commit }, chapter: Chapter) {
      const url = `/api/v1/quizzes/coming_soon_notification/chapter/${chapter.slug}/`;
      return postData(url).then(response => {
        if (response.success) {
          commit('setNotifyComingSoon', { chapterId: chapter.chapter_id });
        }
      });
    },
  },
};

export default chapters;
